import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { Link } from 'react-router-dom';

function AddWorkshopmst({ setShowForm, selectedBoy, refreshManagers }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: selectedBoy?.id || null,
    name: selectedBoy?.name || "",
    // phone: selectedBoy?.phone || "",
    address: selectedBoy?.address || "",
    // city: selectedBoy?.city || "",
    area: selectedBoy?.area || "",
    pincode: selectedBoy?.pincode || "",
    // aadhar_card: selectedBoy?.aadhar_card || "",
    // driving_licence: selectedBoy?.driving_licence || "",
    // address_proof: null,
    // profile_image: null,
    // address_proof_url: selectedBoy?.address_proof_url || "",
    // profile_url: selectedBoy?.profile_url || "",
  });

  useEffect(() => {


    if (selectedBoy) {
      setFormData({
        id: selectedBoy.id || null,
        name: selectedBoy.name || "",
        // phone: selectedBoy.phone || "",
        address: selectedBoy.address || "",
        // city: selectedBoy?.city || "",
        area: selectedBoy?.area || "",
        pincode: selectedBoy?.pincode || "",
        // aadhar_card: selectedBoy.aadhar_card || "",
        // driving_licence: selectedBoy.driving_licence || "",
        // address_proof: selectedBoy.address_proof || null,
        // profile_image: selectedBoy.profile_image || null,
        // address_proof_url: selectedBoy?.address_proof_url || "",
        // profile_url: selectedBoy?.profile_url || "",
      });
    }
  }, [selectedBoy]);

  // Handle form field changes
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
     console.log("Form submitted"); 
     
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    setLoading(true);
   
    const isEditing = Boolean(selectedBoy && selectedBoy.id);

    const url = isEditing
      ? "https://devapi.bykit.in/api/admin/update_workshopaddress??type=live"
      : "https://devapi.bykit.in/api/admin/add_workshopaddress??type=live";

    const payload = {
      address: formData.address,
      area: formData.area,
      pincode: formData.pincode,
      name: formData.name,
      ...(selectedBoy?.id && { id: selectedBoy.id })
    };
    try {
      const response = await axios.post(url, payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('manager account ', response)
      if (response.data?.status) {

        toast.success(formData.id ? "Delivery Boy updated successfully!" : "Delivery Boy added successfully!");
        setFormData({
          id: null,
          name: "",
          // phone: "",
          address: "",
          //city: "",
          area: "",
          pincode: "",
          // aadhar_card: "",
          // driving_licence: "",
          // address_proof: null,
          // profile_image: null,
        });
        refreshManagers();
        setShowForm(false);
      }
    } catch (error) {
      console.error("Error updating status:", error.response?.data || error.message);
    }




    // const formDataToSend = new FormData();
    // formDataToSend.append("id", formData.id);
    // formDataToSend.append("address", formData.address);
    // // formDataToSend.append("city", formData.city);
    // formDataToSend.append("area", formData.area);
    // formDataToSend.append("pincode", formData.pincode);
    // // formDataToSend.append("aadhar_card", formData.aadhar_card);
    // // formDataToSend.append("driving_licence", formData.driving_licence);
    // // formDataToSend.append("profile_image", formData.profile_image);
    // // formDataToSend.append("address_proof", formData.address_proof);

    // try {
    //   const url = formData.id
    //     ? "https://devapi.bykit.in/api/admin/delivery-boys/update??type=live"
    //     : "https://devapi.bykit.in/api/admin/add_workshopaddress/add??type=live";

    //   const response = await axios.post(url, formDataToSend, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   if (response.data.status === "RC200") {
    //     toast.success(formData.id ? "Delivery Boy updated successfully!" : "Delivery Boy added successfully!");
    //     setFormData({
    //       id: null,
    //       // name: "",
    //       // phone: "",
    //       address: "",
    //       //city: "",
    //       area: "",
    //       pincode: "",
    //       // aadhar_card: "",
    //       // driving_licence: "",
    //       // address_proof: null,
    //       // profile_image: null,
    //     });
    //     refreshManagers();
    //     setShowForm(false);
    //   } else {
    //     toast.error(response.data?.message || "Failed to process request. Please try again.");
    //   }
    // } catch (error) {
    //   toast.error("An error occurred. Please try again.");
    // } finally {
    //   setLoading(false);
    // }


  };

  return (
    <div className='p-3' data-aos="fade-up">
      <ToastContainer />
      <div className='managebrand_box mt-3'>
        <h4 className='dashboard_head py-4 ps-4 m-0'>{formData.id ? "Edit" : "Add"} Godown</h4>
        <hr className='p-0 m-0' />
        <div className='p-4'>
          <form onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-md-3">
                <label className="form-label signin_label">Name</label>
                <input
                  type='text'
                  name="name"
                  className='form-control'
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {/* <div className="col-md-3">
                <label className="form-label signin_label">Phone Number</label>
                <input
                  type='text'
                  name="phone"
                  className='form-control'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div> */}
              <div className="col-md-3">
                <label className="form-label signin_label">Address</label>
                <input
                  type='text'
                  name="address"
                  className='form-control'
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* <div className="col-md-3">
                <label className="form-label signin_label">City</label>
                <input
                  type='text'
                  name="city"
                  className='form-control'
                  value={formData.city}
                  onChange={handleInputChange}
                  required
                />
              </div> */}




              <div className="col-md-3">
                <label className="form-label signin_label">Area</label>
                <input
                  type='text'
                  name="area"
                  className='form-control'
                  value={formData.area}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Pincode</label>
                <input
                  type='text'
                  name="pincode"
                  className='form-control'
                  value={formData.pincode}
                  onChange={handleInputChange}
                  required
                />
              </div>


              {/* <div className="col-md-3">
                <label className="form-label signin_label">Driving Licence</label>
                <input
                  type='text'
                  name="driving_licence"
                  className='form-control'
                  value={formData.driving_licence}
                  onChange={handleInputChange}
                  required
                />
              </div> */}
            </div>
            {/* 
            <div className="row mt-4">
              <div className="col-md-3">
                <label className="form-label signin_label">Profile Image</label>
                <input
                  type='file'
                  name="profile_image"
                  className='form-control'
                  onChange={handleInputChange}

                />
                {formData.profile_url && (
                  <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open((formData.profile_url), "_blank");
                    }}
                  >
                    View Profile Image
                  </Link>
                )}
              </div>

              <div className="col-md-3">
                <label className="form-label signin_label">Aadhar Card Number</label>
                <input
                  type='text'
                  name="aadhar_card"
                  className='form-control'
                  value={formData.aadhar_card}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label signin_label">Address Proof (Optional)</label>
                <input
                  type='file'
                  name="address_proof"
                  className='form-control'
                  onChange={handleInputChange}
                />
                {formData.address_proof_url && (
                  <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open((formData.address_proof_url), "_blank");
                    }}
                  >
                    View Address Proof
                  </Link>
                )}
              </div>
            </div> */}

            <div className="d-flex justify-content-end mt-3">
              <button type="submit" className="btn submit_btn" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddWorkshopmst;
